var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cspan class=\"k-highlight-matched-text\"\u003E{{vm.beforeMatch}}\u003Cspan class=\"matched-text\"\u003E{{vm.match}}\u003C\u002Fspan\u003E{{vm.afterMatch}}\u003C\u002Fspan\u003E";;return pug_html;};
module.exports = template;